import { useMemo } from 'react';
import { keyBy } from 'lodash';

import { useQueryIntegrationNames } from '@ion/api';

export default function useIntegrationNamesById() {
  const { integrations } = useQueryIntegrationNames();

  const integrationNamesById = useMemo(() => {
    return keyBy(integrations, 'id');
  }, [integrations]);

  return integrationNamesById;
}
